import classNames from 'classnames';
import PropTypes from 'prop-types';

const DollarCircleIcon = ({ className }) => {
  return (
    <svg
      className={classNames('dollar-circle-icon', className)}
      width='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99992 0.833328C4.04188 0.833328 0.833252 4.04195 0.833252 8C0.833252 11.958 4.04188 15.1667 7.99992 15.1667C11.958 15.1667 15.1666 11.958 15.1666 8C15.1666 4.04195 11.958 0.833328 7.99992 0.833328ZM7.49992 4.33333V4.87621C7.08702 4.94813 6.70863 5.10823 6.40247 5.33915C5.97587 5.66091 5.66658 6.1428 5.66658 6.71608C5.66658 7.22133 5.84186 7.6916 6.29968 8.00685C6.71708 8.29427 7.29973 8.40127 7.99992 8.40127C8.63721 8.40127 9.01454 8.49959 9.22257 8.63828C9.38739 8.74816 9.49992 8.91858 9.49992 9.28398C9.49992 9.59495 9.3742 9.78349 9.15252 9.91959C8.90069 10.0742 8.50535 10.1667 7.99992 10.1667C7.53631 10.1667 7.13838 10.0359 6.87004 9.85041C6.59969 9.66351 6.49992 9.45504 6.49992 9.28398H5.49992C5.49992 9.87658 5.84786 10.3594 6.30137 10.673C6.63602 10.9043 7.04976 11.0622 7.49992 11.1297V11.6667H8.49992V11.1404C8.92628 11.0936 9.33547 10.9807 9.67574 10.7718C10.1779 10.4635 10.4999 9.96066 10.4999 9.28398C10.4999 8.66173 10.2791 8.1408 9.77727 7.80623C9.31863 7.50047 8.69596 7.40127 7.99992 7.40127C7.36678 7.40127 7.03276 7.2975 6.86682 7.18323C6.74131 7.0968 6.66658 6.97448 6.66658 6.71608C6.66658 6.52571 6.76771 6.31622 7.00464 6.13752C7.24181 5.95863 7.59204 5.83333 7.99992 5.83333C8.40779 5.83333 8.75802 5.95863 8.9952 6.13752C9.23213 6.31622 9.33325 6.52571 9.33325 6.71608H10.3333C10.3333 6.1428 10.024 5.66091 9.59736 5.33915C9.2912 5.10823 8.91282 4.94813 8.49992 4.87621V4.33333H7.49992Z'
      />
    </svg>
  );
};

DollarCircleIcon.propTypes = {
  className: PropTypes.string,
};

export default DollarCircleIcon;
